import { render, staticRenderFns } from "./accountBind.vue?vue&type=template&id=6aa5175c&scoped=true"
import script from "./accountBind.vue?vue&type=script&lang=js"
export * from "./accountBind.vue?vue&type=script&lang=js"
import style0 from "./accountBind.vue?vue&type=style&index=0&id=6aa5175c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa5175c",
  null
  
)

export default component.exports